var _defs, _rect, _path, _rect2, _rect3, _path2, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTasks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      marginRight: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#545a6d;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 8.9,
    y: 0.81,
    width: 7.28,
    height: 0.37
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.15,2.81V1.18h-2.92c-.32,0-.63,.13-.86,.36-.23,.23-.35,.54-.35,.86V22.72c0,.32,.13,.63,.35,.86,.23,.23,.54,.36,.86,.36h14.43c.32,0,.63-.13,.86-.36,.23-.23,.36-.54,.36-.86V2.4c0-.32-.13-.63-.36-.86-.22-.23-.54-.36-.86-.36h-2.75v1.62h2.75V22.09H5.23V2.81h2.92Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 8.9,
    y: 1.18,
    width: 7.28,
    height: 1.62
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 8.9,
    y: 2.81,
    width: 7.28,
    height: 0.78
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.18,1.18V3.59h-7.28V.81h7.28v.37Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 6.45,
    y: 5.54,
    width: 12.01,
    height: 1.29
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 6.45,
    y: 8.46,
    width: 12.01,
    height: 1.29
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 6.45,
    y: 11.38,
    width: 12.01,
    height: 1.29
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 6.45,
    y: 14.3,
    width: 12.01,
    height: 1.29
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 6.45,
    y: 17.22,
    width: 12.01,
    height: 1.29
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.916db3633886f933832bd0a9fb82ceaf.svg";
export { ForwardRef as ReactComponent };